<template>
	<div class="stacked__group" width="100%">
		<div class="stacked__group__top">
			<div class="stacked__group__top__title">
				{{ home_team | toTitleCase }} vs {{ away_team | toTitleCase }}
			</div>
			<svg @click="removeMatch" width="19" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path opacity="1" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="var(--light-dark-blue)"></path> 
				<path d="M13.06 12L15.36 9.7C15.65 9.41 15.65 8.93 15.36 8.64C15.07 8.35 14.59 8.35 14.3 8.64L12 10.94L9.69998 8.64C9.40998 8.35 8.92999 8.35 8.63999 8.64C8.34999 8.93 8.34999 9.41 8.63999 9.7L10.94 12L8.63999 14.3C8.34999 14.59 8.34999 15.07 8.63999 15.36C8.78999 15.51 8.97999 15.58 9.16999 15.58C9.35999 15.58 9.54998 15.51 9.69998 15.36L12 13.06L14.3 15.36C14.45 15.51 14.64 15.58 14.83 15.58C15.02 15.58 15.21 15.51 15.36 15.36C15.65 15.07 15.65 14.59 15.36 14.3L13.06 12Z" fill="var(--white)"></path>
			</svg>
		</div>
		
		<div class="stacked__group__center">
			<div class="stacked" v-for="(pick, i) in picks" :key="i">
				<svg @click="removePick(pick)" width="19" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path opacity="1" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="var(--light-dark-blue)"></path> 
					<path d="M13.06 12L15.36 9.7C15.65 9.41 15.65 8.93 15.36 8.64C15.07 8.35 14.59 8.35 14.3 8.64L12 10.94L9.69998 8.64C9.40998 8.35 8.92999 8.35 8.63999 8.64C8.34999 8.93 8.34999 9.41 8.63999 9.7L10.94 12L8.63999 14.3C8.34999 14.59 8.34999 15.07 8.63999 15.36C8.78999 15.51 8.97999 15.58 9.16999 15.58C9.35999 15.58 9.54998 15.51 9.69998 15.36L12 13.06L14.3 15.36C14.45 15.51 14.64 15.58 14.83 15.58C15.02 15.58 15.21 15.51 15.36 15.36C15.65 15.07 15.65 14.59 15.36 14.3L13.06 12Z" fill="var(--white)"></path>
				</svg>
				<div class="stacked__details">
					<div class="stacked__row stacked__row--top">
						{{ pick.market | toTitleCase }} •
						{{ pick.odd_key | toTitleCase }}
						<span v-if="pick.special_bet_value"
							>({{ pick.special_bet_value }})</span
						>
					</div>
				</div>
	
				<div class="stacked__row stacked__row--middle">
					<span class="odd-value bold">
						{{ pick.odd_value }}
					</span>
				</div>
			</div>
		</div>

		<div class="stacked__group__bottom">
			<span class="stacked__marker stacked__marker--starttime">
				<span>{{this.$t('betslip.starts')}} {{ picks[0].startTime | time }}</span>
			</span>
			<span class="stacked__total-odd">
				<b>{{ total_odd }}</b>
			</span>
		</div>
		<span
			class="underline_slip"
			:class="{
				'd-none': keyValue === 1,
			}"
		></span>
	</div>
</template>

<script>
export default {
	name: "bet",
	props: ["bet", "keyValue"],
	methods: {
		removeMatch() {
			this.$store.commit("removeFromJengabetBetslip", this.bet.bet[0]);
		},
		removePick(pick) {
			this.$store.commit("removeMarketFromJengabetBetslip", pick);
		},
	},
	computed: {
		picks() {
			return this.bet.bet;
		},
		home_team() {
			return this.bet.bet[0].home_team;
		},
		away_team() {
			return this.bet.bet[0].away_team;
		},
		total_odd() {
			let total_odd = this.bet.bet.reduce((a, b) => a * b.odd_value, 1);
			return Math.round(total_odd * 100) / 100;
		},
	},
};
</script>
